var exports = {
  "k": "xe564cbfb--1c1f15--container",
};

module.exports = exports;
